import { api } from './services';

export const runIndirectRules = async () => await api('workflow/runIndirectRules', {}, 'post');
